<template lang="pug">
  app-plotly(v-if="graficoDados.length > 0" :nomeDiv="idDiv", :dados="graficoDados", :layout="layout")
  .empty(
    v-else,
    style="width: 100%; height: 450px; padding: 50px")
        span.texto Nenhum dado a ser exibido.

</template>

<script>
import AppPlotly from '@/components/AppPlotly'
import GRAFICO from '@/constants/grafico'
import EmptyAnimation from '@/screens/demandas/components/EmptyAnimation'
import { isEmpty } from 'lodash'

export default {
  components: {
    AppPlotly,
    EmptyAnimation
  },

  props: {
    idDiv: {
      type: String,
      required: true
    },
    dados: {
      type: Array,
      required: true
    },
    layoutOptions: {
      type: Object
    },
    keyX: {
      required: true
    },
    keyY: {
      required: true
    },
    keyText: {
      type: String,
      required: true
    },
    titulo: {
      type: String
    },
    tituloY: {
      type: String,
      default: 'Quantidade de demandas'
    },
    tituloX: {
      type: String,
      default: 'Painel'
    },
    cores: {
      type: Array,
      default: () => {
        return GRAFICO.CORES
      }
    },
    zoom: Boolean,
    switchText: {
      texto: String,
      template: String
    },
    showTituloGrafico: {
      type: Boolean,
      default: true
    }

  },

  data () {
    return {
      colors: this.cores,
      loading: true
    }
  },

  computed: {
    dadosWithColor () {
      return this.dados.map((dado, index) => ({
        ...dado,
        color: this.colors[index]
      }))
    },
    graficoDados () {
      if (isEmpty(this.dados)) {
        return []
      }

      const graficoDados = []

      this.dadosWithColor.forEach((dadoWithColor, index) => {
        let novoGrafico = {
          x: [],
          y: [],
          text: [],
          textposition: 'auto',
          hoverinfo: 'none',
          marker: { color: [] },
          type: 'bar',
          showlegend: true,
          width: this.dadosWithColor.length <= 5 ? 0.4 : 'auto',
          hovertemplate: this.switchText?.template + ' ' + this.switchText?.texto + '<extra></extra>'
        }

        novoGrafico.x.push(dadoWithColor[this.keyX])

        novoGrafico.y.push(dadoWithColor[this.keyY])

        novoGrafico.text.push(dadoWithColor[this.keyText])

        novoGrafico.name = dadoWithColor[this.keyX]

        novoGrafico.marker.color.push(dadoWithColor.color)

        graficoDados.push(novoGrafico)
      })

      return graficoDados
    },

    layout () {
      return {
        title: this.titulo ? `<b>${this.titulo}</b>` : '',
        titlefont: {
          size: 20,
          weight: 'bold'
        },
        xaxis: {
          title: this.showTituloGrafico ? this.tituloX : '',
          automargin: true,
          showticklabels: true,
          fixedrange: !this.zoom
        },
        yaxis: {
          title: this.tituloY,
          titlefont: {
            size: 16,
            color: 'rgb(107, 107, 107)'
          },
          tickfont: {
            size: 14,
            color: 'rgb(107, 107, 107)'
          },
          fixedrange: !this.zoom
        },
        legend: {
          font: {
            size: 10
          }
        },
        hovermode: 'closest',
        separators: ',.',
        ...this.layoutOptions
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.texto{
    margin-right: 4.5%;
}
</style>



// WEBPACK FOOTER //
// src/screens/demandas/components/Grafico.vue